// extracted by mini-css-extract-plugin
export var results = "VolunteerVacancyResults-module--results--ea093";